"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Animator_1 = require("../Animator");
var UsageCache_1 = require("engine/ds/UsageCache");
var Object2D_1 = require("engine/ui/Object2D");
var UIConstants_1 = require("../ui/UIConstants");
var TileLoader_1 = require("./TileLoader");
var TrackObject_1 = require("./TrackObject");
var ShaderTrack = /** @class */ (function (_super) {
    __extends(ShaderTrack, _super);
    function ShaderTrack(model, customTileNodeClass) {
        var _this = _super.call(this, model) || this;
        _this.customTileNodeClass = customTileNodeClass;
        _this.densityMultiplier = 1.0;
        _this._tileNodeCache = new UsageCache_1.default(function () { return _this.createTileNode(); }, function (t) { return _this.deleteTileNode(t); });
        return _this;
    }
    ShaderTrack.prototype.updateDisplay = function (samplingDensity, continuousLodLevel, span, widthPx) {
        var _this = this;
        this._tileNodeCache.markAllUnused();
        if (widthPx > 0) {
            var tileLoader_1 = this.getTileLoader();
            tileLoader_1.forEachTile(this.x0, this.x1, samplingDensity, true, function (tile) {
                var tileNode = _this._tileNodeCache.get(_this.contig + ':' + tile.key);
                _this.updateTileNode(tileNode, tile, _this.x0, span, continuousLodLevel);
                // main tiles are positioned front-most so they appear above any fallback tiles
                tileNode.z = 1.0;
                // if tileNode is not opaque and displaying data then we've got a gap to fill
                if (!_this.tileNodeIsOpaque(tileNode)) {
                    var gapCenterX = tile.x + tile.span * 0.5;
                    // limit the number of loading-fade-in tiles to improve performance
                    var loadingTilesAllowed = 1;
                    var fadingTilesAllowed = 1;
                    // fill with larger tiles (higher lod level)
                    for (var p = 1; p < 30; p++) {
                        var densityMultiplier = 1 << p; // p must not exceed 30 or 1 << p will overflow
                        var fallbackDensity = samplingDensity * densityMultiplier;
                        // exhausted all available lods
                        if (!tileLoader_1.isWithinInitializedLodRange(fallbackDensity))
                            break;
                        var fallbackTile = tileLoader_1.getTile(gapCenterX, fallbackDensity, false);
                        // it's possible we end up with the same lod we already have, if so, skip it
                        if (fallbackTile.lodLevel === tile.lodLevel)
                            continue;
                        // can we use this tile as a fallback?
                        if (((loadingTilesAllowed > 0) && (fallbackTile.state === TileLoader_1.TileState.Loading)) ||
                            (fallbackTile.state === TileLoader_1.TileState.Complete)) {
                            if (fallbackTile.state === TileLoader_1.TileState.Loading) {
                                loadingTilesAllowed--;
                            }
                            var fallbackNode = _this._tileNodeCache.get(_this.contig + ':' + fallbackTile.key);
                            _this.updateTileNode(fallbackNode, fallbackTile, _this.x0, span, continuousLodLevel);
                            // z-position tile so that better lods are front-most
                            fallbackNode.z = (1.0 - fallbackTile.lodLevel / 50) - 0.1;
                            // remove the tile if it's currently fading in and we've run out of fading tile budget
                            var tileIsFading = (fallbackTile.state === TileLoader_1.TileState.Complete) && (fallbackNode.opacity < 1);
                            if (tileIsFading) {
                                if (fadingTilesAllowed <= 0) {
                                    // this is a fading tile and we've run out of fading tile budget
                                    // mark it as unused so it's removed by UsageCache
                                    _this._tileNodeCache.markUnused(_this.contig + ':' + fallbackTile.key);
                                    continue;
                                }
                                else {
                                    fadingTilesAllowed--;
                                }
                            }
                            // if the fallback node is opaque then we've successfully plugged the gap
                            if (_this.tileNodeIsOpaque(fallbackNode)) {
                                break;
                            }
                        }
                    }
                }
            });
        }
        this._tileNodeCache.removeUnused();
    };
    ShaderTrack.prototype.createTileNode = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        // create empty tile node
        var tileNode = new ((_a = this.customTileNodeClass).bind.apply(_a, __spread([void 0], args)))();
        tileNode.mask = this;
        this.add(tileNode);
        return tileNode;
    };
    ShaderTrack.prototype.deleteTileNode = function (tileNode) {
        tileNode.setTile(null); // ensure cleanup is performed
        tileNode.releaseGPUResources();
        this.remove(tileNode);
    };
    ShaderTrack.prototype.updateTileNode = function (tileNode, tile, x0, span, displayLodLevel) {
        tileNode.relativeX = (tile.x - x0) / span;
        tileNode.relativeW = tile.span / span;
        tileNode.relativeH = 1;
        tileNode.displayLodLevel = displayLodLevel;
        tileNode.setTile(tile);
    };
    ShaderTrack.prototype.tileNodeIsOpaque = function (tileNode) {
        return (tileNode.render === true) &&
            (tileNode.opacity >= 1) &&
            (tileNode.getTile().state === TileLoader_1.TileState.Complete);
    };
    return ShaderTrack;
}(TrackObject_1.TrackObject));
exports.ShaderTrack = ShaderTrack;
var ShaderTile = /** @class */ (function (_super) {
    __extends(ShaderTile, _super);
    function ShaderTile() {
        var _this = _super.call(this) || this;
        _this.tileCompleteListener = function (completedTile) {
            if (completedTile !== _this.tile) {
                // a bug in EventEmitter (or maybe V8?) is causing the removeEventListener when changing tile to not work properly
                return;
            }
            _this.tile.removeEventListener('complete', _this.tileCompleteListener);
            _this.onTileComplete();
        };
        _this.opacity = 1;
        _this.render = false;
        return _this;
    }
    Object.defineProperty(ShaderTile.prototype, "opacity", {
        get: function () {
            return this._opacity;
        },
        set: function (opacity) {
            this._opacity = opacity;
            // switch to opaque rendering as soon as opacity hits 1
            this.transparent = opacity < 1;
        },
        enumerable: true,
        configurable: true
    });
    ShaderTile.prototype.setTile = function (tile) {
        // early exit case
        if (tile === this.tile)
            return;
        if (this.tile != null) {
            this.tile.removeEventListener('complete', this.tileCompleteListener);
        }
        this.tile = tile;
        if (tile != null) {
            if (tile.state === TileLoader_1.TileState.Complete) {
                this.opacity = 1;
                this.onTileComplete();
            }
            else {
                tile.addEventListener('complete', this.tileCompleteListener);
                this.opacity = 0;
                this.render = false;
            }
        }
        else {
            this.render = false;
        }
    };
    ShaderTile.prototype.getTile = function () {
        return this.tile;
    };
    ShaderTile.prototype.onTileComplete = function () {
        Animator_1.default.springTo(this, { 'opacity': 1 }, UIConstants_1.DEFAULT_SPRING);
        this.render = true;
        this.gpuResourcesNeedAllocate = true;
    };
    return ShaderTile;
}(Object2D_1.default));
exports.ShaderTile = ShaderTile;
exports.default = ShaderTrack;
